import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { ComposableMap, ZoomableGroup, Geographies, Geography } from 'react-simple-maps';
import geographyData from './world-50m.json';


const mapStyles = (id, children) => {
    const colorGroup = Children.toArray(children).find(colorGroup => colorGroup.props.countries.includes(id));
    if (!colorGroup) return null;
    return {
        default: {
            fill: colorGroup.props.color,
            outline: 'none',
        },
        hover: {
            fill: colorGroup.props.colorHover || colorGroup.props.color,
            outline: 'none',
        },
        pressed: {
            fill: colorGroup.props.color,
            outline: 'none',
        },
    };
};


const ChoroplethMulticolor = ({ countriesExcluded, children, colorDefault }) => (
    <ComposableMap
        projection="miller"
        projectionConfig={{ scale: 150, rotation: [-10, 0, 0], yOffset: -15 }}
        height={512}
        width={1050}
        style={{ height: '100%', width: '100%' }}
    >
        <ZoomableGroup
            center={[10, 20]}
            disablePanning
        >
            <Geographies
                geography={geographyData}
                disableOptimization
            >
                {
                    (geographies, projection) => geographies.map(geography => !countriesExcluded.includes(geography.id) && (
                        <Geography
                            geography={geography}
                            key={geography.id}
                            projection={projection}
                            style={
                                mapStyles(geography.id, children) ||
                                {
                                    default: {
                                        fill: colorDefault,
                                        outline: 'none',
                                    },
                                    hover: {
                                        fill: colorDefault,
                                        outline: 'none',
                                    },
                                    pressed: {
                                        fill: colorDefault,
                                        outline: 'none',
                                    }
                                }
                            }
                        />
                    ))
                }
            </Geographies>
        </ZoomableGroup>
    </ComposableMap>
);


ChoroplethMulticolor.defaultProps = {
    countriesExcluded: [],
    colorDefault: '#b2b2b2',
};

ChoroplethMulticolor.propTypes = {
    countriesExcluded: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.node,
    colorDefault: PropTypes.string,
};


export default ChoroplethMulticolor;
